module.exports = __webpack_public_path__ + "img/datacenter7.7c357276.png";